export default "__VITE_ASSET__15510b0e__"